export const CARD_DRAGGABLE_ID_PREFIX = 'CARD_DRAGGABLE_ID' as const;
